/* Search uses the same catalog cutouts as product cards, only for this store. */
(() => {
  const config = window.IllegalShirts || {};
  const origin = location.origin;
  const storeHosts = new Set(['shopillegalshirts.com', 'www.shopillegalshirts.com', 'polandshirts.myshopify.com']);
  let imageMap = {};
  const reliability = window.StorefrontReliability;
  const mapCache = reliability.cache(async () => {
    if (!config.product_image_map) return {};
    return reliability.request(config.product_image_map, { timeout: 1800 });
  });
  const ready = () => mapCache().then(map => { if(map && typeof map === 'object') imageMap = map; }).catch(() => {});
  window.addEventListener('online', () => mapCache.invalidate());
  function eligible(source, options = {}) {
    if (options.external || !options.productUrl) return false;
    try {
      const product = new URL(options.productUrl, origin);
      const image = new URL(source, origin);
      if (!storeHosts.has(product.hostname) || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(product.pathname) || /custom/i.test(product.pathname)) return false;
      if (!['https:', 'http:'].includes(image.protocol) || /\/uploads\//i.test(image.pathname)) return false;
      return (image.hostname === 'cdn.shopify.com' && image.pathname.startsWith('/s/files/1/0555/6643/4592/files/')) ||
        (storeHosts.has(image.hostname) && image.pathname.startsWith('/cdn/shop/files/'));
    } catch (_) { return false; }
  }
  function url(source, width = 640, options = {}) {
    if (!source || !eligible(source, options)) return source || '';
    const original = new URL(source, origin);
    let filename;
    try { filename = decodeURIComponent(original.pathname.split('/').pop()); } catch (_) { return source; }
    const asset = imageMap[filename];
    if (typeof asset === 'string' && config.product_asset_base) {
      const name = width <= 400 && /^cutout-\d+(?:-v\d+)?\.webp$/.test(asset) ? asset.replace(/\.webp$/, '-400.webp') : asset;
      return new URL(name, new URL(config.product_asset_base, origin)).href;
    }
    original.searchParams.set('width', String(width));
    return '/apps/illegal-cutouts/image?src=' + encodeURIComponent(original.href) + '&w=' + width + '&cv=8';
  }
  function apply(image, source, width, options) {
    if (!eligible(source, options)) { image.src = source; return image; }
    image.style.objectFit = 'contain';
    image.src = source;
    // Wait for the catalog map before selecting a cutout; fast search responses
    // must not permanently select the automatic fallback while the map loads.
    void ready().then(() => reliability.swapImage(image, url(source, width, options), { fallback: source, alt: image.alt, sizes: image.sizes })).catch(() => {});
    return image;
  }
  window.IllegalProductImages = { ready, url, apply, eligible };
})();
